'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TDynamicData } from '../../types/dynamic-data';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';

export const InspirationCard = ({ inspiration }: { inspiration: TDynamicData }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  const allImages = [inspiration.image, ...(inspiration?.fields[1]?.images || [])];

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="relative col-span-1 h-[220px] w-full cursor-pointer overflow-hidden rounded-[16px] md:h-[260px] lg:h-[360px]">
        <Image
          onClick={handleOpenGallery(allImages, 0)}
          src={inspiration?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(inspiration?.image, inspiration?.name)}
          fill
          className="object-cover object-center"
          sizes="100vw"
        />
      </div>
    </>
  );
};
